import { formatDate } from '@angular/common';
import { Component, OnInit, OnDestroy, Inject, Input } from '@angular/core';



@Component({
	selector: 'last-save-msg',
	templateUrl: './last-save-msg.component.html',
	styleUrls: [ './last-save-msg.component.css' ],
	standalone: true
})
export class LastSaveMsgComponent implements OnInit, OnDestroy {


	_tmsLastSaveStart: number | null = null;
	@Input() set tmsLastSaveStart( val: number | null ) {
		this._tmsLastSaveStart = val;
		this.refreshMsg();
	};

	_tmsLastSaveEnd: number | null = null;
	@Input() set tmsLastSaveEnd( val: number | null ) {
		this._tmsLastSaveEnd = val;
		this.refreshMsg();
	}

	msgLastSave = "";
	intervalRefreshLastSaveMsg = 0;


	constructor() {}


	ngOnInit() {

		this.intervalRefreshLastSaveMsg = window.setInterval( () => {

			this.refreshMsg();

		}, 1000 );


	}

	ngOnDestroy() {
		clearInterval( this.intervalRefreshLastSaveMsg );
	}


	private refreshMsg() {

		if( this._tmsLastSaveStart === null ) {
			this.msgLastSave = "";
		}
		else if(
			( this._tmsLastSaveEnd === null )
			|| ( this._tmsLastSaveEnd < this._tmsLastSaveStart )
		) {
			this.msgLastSave = "Automatisches Speichern läuft…";
		}
		else {

			const dt = new Date();
			const tmsNow = dt.getTime();
			const secsDiff = Math.round( ( tmsNow - this._tmsLastSaveEnd ) / 1000 );
			if( secsDiff < 60 ) {
				this.msgLastSave = "Vor ein paar Sekunden automatisch gespeichert";
			}
			else if( ( secsDiff > 60 ) && ( secsDiff < 2*60 ) ) {
				this.msgLastSave = "Vor einer Minute automatisch gespeichert" ;
			}
			else if( ( secsDiff > 2*60 ) && ( secsDiff < 3600 ) ) {
				this.msgLastSave = "Vor ein paar Minuten automatisch gespeichert" ;
			}
			else {
				this.msgLastSave = "Vor mehr als einer Stunde automatisch gespeichert";
			}
			this.msgLastSave += " (um " + formatDate( this._tmsLastSaveEnd, "HH:mm", "de" ) + ")"

		}

	}

}

